export const dataHooks = {
  dropzoneOverlay: 'dropzone-overlay',
  dropzoneContent: 'dropzone-content',
};
